import {Component, HostListener, OnInit} from '@angular/core';
import {NgClass, NgOptimizedImage} from '@angular/common';
import {RouterLink} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';

import {AppService} from 'shared/services';
import {TokenUserModel} from 'shared/models';
import {ToggleService} from '../sidebar/toggle.service';
import {CustomizerSettingsService} from '../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgClass, MatMenuModule, MatButtonModule, RouterLink, NgOptimizedImage],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;

  protected currentUser?: TokenUserModel;

  constructor(
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    private appService: AppService
  ) {
    this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit() {
    this.currentUser = this.appService.currentUser;
  }

  // Burger Menu Toggle
  toggle() {
    this.toggleService.toggle();
  }

  // Header Sticky
  isSticky = false;
  @HostListener('window:scroll', ['$event'])
  checkScroll(event: Event) {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  // Dark Mode
  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
